import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { QtChevronLeft } from "../../components/icons/QtIcon";
import { TRAINING } from "../academy/trainingTerms";
import {
  scrollTrainingToTop,
  TrainingAccountSubnav,
  TrainingBreadcrumbs,
  TrainingSignOutSection,
} from "../academy/AcademyShared";
import CareersFooter from "../../components/CareersFooter";

export default function MeLayout({
  title,
  children,
  backTo = "/academy",
  breadcrumbs,
  /** "programs" = training account chrome; "creator" = standalone Creator Program shell */
  realm = "programs",
}) {
  const location = useLocation();
  const isCreator = realm === "creator";

  useEffect(() => {
    scrollTrainingToTop({ instant: true });
  }, [location.pathname]);

  const backLabel =
    backTo === "/academy"
      ? `Back to ${TRAINING.programs.toLowerCase()}`
      : backTo === "/creator"
        ? "Back to Creator Program"
        : backTo === "/me/creator"
          ? "Back to Creator"
          : backTo === "/me/creator/work"
            ? "Back to My work"
            : "Back";

  const brandTo = isCreator ? "/creator" : "/";
  const brandAccent = isCreator ? "Careers" : "Programs";

  return (
    <div className={`training-center${isCreator ? " training-center--creator" : ""}`}>
      <div className="training-center__bg" aria-hidden="true" />
      <header className="training-header">
        <Link to={backTo} className="training-header-back" aria-label={backLabel}>
          <QtChevronLeft />
        </Link>
        <div className="training-header-title-wrap">
          <Link to={brandTo} className="training-header-brand">
            QikTruck <span>{brandAccent}</span>
          </Link>
          <h1 className="training-header-title">{title}</h1>
        </div>
        <span className="training-header-spacer" aria-hidden="true" />
      </header>

      <div className="training-shell">
        {isCreator ? null : (
          <TrainingAccountSubnav ariaLabel="Account sections" />
        )}
        {breadcrumbs?.length > 0 ? (
          <TrainingBreadcrumbs
            items={breadcrumbs}
            className="training-shell__breadcrumbs"
          />
        ) : null}

        <main className="training-body">
          {children}
          <TrainingSignOutSection />
        </main>
      </div>
      <CareersFooter />
    </div>
  );
}
